'use client'
export { ScrollInfoProvider, useScrollInfo } from '@faceless-ui/scroll-info'
